import { useMemo } from 'react'

import { type JourneyQueryParams } from '../types'
import { parseUuidOrValue } from '../utils/parse'

import { useAppManagerContext } from './useAppManagerContext'

/**
 * @deprecated remove when data injection and context are supported by useAppParams
 */
export const useGetJourneyParams = () => {
  const {
    appParams: { contextData }
  } = useAppManagerContext()

  return useMemo<JourneyQueryParams>(() => {
    const searchParams = new URLSearchParams(window.location.search)

    return {
      ...searchParams.values(),
      dataInjectionOptions: searchParams.get('dataInjectionOptions'),
      contextData: Array.from(searchParams.entries()).reduce(
        (acc, [key, value]) => {
          acc[key] = parseUuidOrValue(value)

          return acc
        },
        contextData
      )
    }
  }, [contextData])
}
